import Vue from "vue";
import Vuex from "vuex";
import Router from "vue-router";
import App from "./app.vue";

import Home from "./views/home/Home";
import Documents from "./views/documents/Documents";
import News from "./views/news/News";
import Products from "./views/products/Products";
import Search from "./views/search/Search";
import Basket from "./views/basket/Basket";
import Images from "./views/images/Images";
import Filter from "./views/filter/Filter";

Vue.config.debug = true;

Vue.use(Vuex);
Vue.use(Router);
Vue.use(require("vue-resource"));

var router = new Router();

router.map({
  "/": {
    component: Home
  },
  "/documents/:id": {
    component: Documents
  },
  "/documents/:fileTypeId/:categoryId/:itemId": {
    component: Documents
  },
  "/products/:id/filetype/:fileTypeId": {
    component: Products
  },
  "/search/:fileTypeId/:searchString": {
    component: Search
  },
  "/search/:fileTypeId/product/:itemId": {
    component: Search
  },
  "/images/filter/:null": {
    component: Filter
  },
  "/images/product/:id": {
    component: Images
  },
  "/images/:id": {
    component: Products
  },
  "/news/:id": {
    component: News
  },
  "/basket": {
    component: Basket
  }
});

 /*
LIVE SETTNGS:
Vue.http.options.root = "";
Vue.http.options.profilerUrl = "https://profilerservices.ricoh-portal.info";
Vue.http.options.chameleonUrl = "https://www.ricoh-chameleon.info";
NEW LIVE SETTNGS:
Vue.http.options.root = "";
Vue.http.options.profilerUrl = "https://temp-profilerservices.ricoh-portal.info";
Vue.http.options.chameleonUrl = "https://wwwtemp.ricoh-chameleon.info";
QA SETTNGS:
Vue.http.options.root = "";
Vue.http.options.profilerUrl = "https://profiler.stage.ricoh-portal.info";
Vue.http.options.chameleonUrl = "https://chameleon-api.stage.ricoh-portal.info";
NEW QA SETTINGS:
Vue.http.options.root = "";
Vue.http.options.profilerUrl = "http://temp-profiler.stage.ricoh-portal.info";
Vue.http.options.chameleonUrl = "http://temp-chameleon-api.stage.ricoh-portal.info";
LOCALHOST SETTINGS:
Vue.http.options.root = "";
Vue.http.options.profilerUrl = "https://temp-profilerservices.ricoh-portal.info";
Vue.http.options.chameleonUrl = "https://wwwtemp.ricoh-chameleon.info";
 */

Vue.http.options.emulateJSON = true;
Vue.http.options.root = "";
Vue.http.options.profilerUrl = "https://temp-profilerservices.ricoh-portal.info";
Vue.http.options.chameleonUrl = "https://wwwtemp.ricoh-chameleon.info";
Vue.http.interceptors.push({
  response: function (response) {
    if (response.status === 401) {
      window.localStorage.setItem("access_token", "");
      document.location.reload();
    }
    return response;
  }
});

router.start(App, "body");



// WEBPACK FOOTER //
// ./src/main.js